import { InspectionRegion } from "./InspectionRegion"

export class GeneralSettings {
    CurrentPage: Boolean;
    AllPages: Boolean;
    BulkheadsNoStifffners: Boolean;
    DeleteOldAutomaticPoints: Boolean;
    Date: string;
    Regions: any[];
    ElementIds: string[] = [];
}
